require('./bootstrap');

window.BpmnModeler = require('camunda-bpmn-js/lib/camunda-platform/Modeler')

$(document).ready(function () {

    $('[data-toggle="tooltip"]').tooltip();

    const sidebarList = document.querySelectorAll('.sidebar-platform .sidebar-list .li-parent');
    const sidebarContent = document.querySelector('.sidebar-platform .sidebar-content');
    if(sidebarList.length){
        sidebarList.forEach((li, index) => {
            const nextLi = li.nextElementSibling;
            li.addEventListener('mouseover', () => {
                sidebarContent.style.overflow = 'visible';
                index === 0 ? li.style.top = '-50px' : li.style.top = `${index * 50}px`;
            });
            li.addEventListener('mouseout', () => {
                sidebarContent.style.overflow = null;
                li.style.top = null;
            })
        });
    }

    $('.tree-toggle').click(function () {
        if($('#app').hasClass('menu-open')){
            $(this).parent().children('ul.tree-content').slideToggle(200);
            $(this).toggleClass('active');
        }
    });

    $('.menu-trigger').click(function () {
        // sidebarTreeParentsRemoveStyles();
        axios.get('/ru/set_open_menu').then(resp => {
            console.log(resp.data);
        });
        if ($('#app').hasClass("menu-open")) {
            $('#app').removeClass('menu-open');
        } else {
            $('#app').addClass('menu-open');
        }
    })

    $(".filter-trigger").on("click", function (event) {
        event.stopPropagation();
        $("#filter_block").slideToggle(200);
        $(this).toggleClass('active')
    });
});


